import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'

export default [
  {
    path: '/staff',
    name: 'staff',
    meta: { title: '人员' },
    redirect: '/staff/lists',
    component: Main,
    children: [
      // 员工管理
      {
        path: '/staff/lists',
        name: 'staff_lists',
        meta: {
          title: '员工管理',
          parentPath: '/staff',
          icon: 'icon_yuangongguanli',
          permission: ['view'],
          keepAlive: true
        },
        component: () => import('@/views/staff/lists.vue')
      },

      // 工种管理
      {
        path: '/staff/worker-type',
        name: 'staff_worker_type',
        meta: {
          title: '工种管理',
          parentPath: '/staff',
          icon: 'icon_gongzhong',
          permission: ['view'],
          keepAlive: true
        },
        component: () => import('@/views/staff/worker-type/lists.vue')
      },

      // 薪酬规则
      {
        path: '/staff/salary-rule',
        name: 'staff_salary_rule',
        meta: {
          title: '薪酬规则',
          parentPath: '/staff',
          icon: 'icon_xinchou',
          permission: ['view'],
          keepAlive: true
        },
        component: () => import('@/views/staff/salary-rule/lists.vue')
      },

      // 排班管理
      // {
      //     path: '/staff/schedule',
      //     name: 'staff_schedule',
      //     meta: {
      //         title: '排班管理',
      //         parentPath: '/staff',
      //         icon: 'icon_paiban',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     component: () => import('@/views/staff/schedule/lists.vue')
      // },

      // 薪酬结算
      {
        path: '/staff/salary-settlement',
        name: 'staff_salary_settlement',
        meta: {
          title: '薪酬结算',
          parentPath: '/staff',
          icon: 'icon_jiesuan',
          permission: ['view'],
          keepAlive: true
        },
        component: () => import('@/views/staff/salary-settlement/lists.vue')
      },

      // 转单记录
      // {
      //     path: '/staff/transfer-record',
      //     name: 'staff_transfer_record',
      //     meta: {
      //         title: '转单记录',
      //         parentPath: '/staff',
      //         icon: 'icon_zhuandan',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     component: () => import('@/views/staff/transfer-record/lists.vue')
      // },

      // ===== 隐藏路由（新增/编辑页面）====

      // 员工新增/编辑
      {
        path: '/staff/add',
        name: 'staff_add',
        meta: {
          hidden: true,
          title: '新增员工',
          parentPath: '/staff',
          prevPath: '/staff/lists'
        },
        component: () => import('@/views/staff/edit.vue')
      },
      {
        path: '/staff/edit',
        name: 'staff_edit',
        meta: {
          hidden: true,
          title: '编辑员工',
          parentPath: '/staff',
          prevPath: '/staff/lists'
        },
        component: () => import('@/views/staff/edit.vue')
      },
      {
        path: '/staff/detail',
        name: 'staff_detail',
        meta: {
          hidden: true,
          title: '员工详情',
          parentPath: '/staff',
          prevPath: '/staff/lists'
        },
        component: () => import('@/views/staff/detail.vue')
      },

      // 工种新增/编辑
      {
        path: '/staff/worker-type/add',
        name: 'staff_worker_type_add',
        meta: {
          hidden: true,
          title: '新增工种',
          parentPath: '/staff',
          prevPath: '/staff/worker-type'
        },
        component: () => import('@/views/staff/worker-type/edit.vue')
      },
      {
        path: '/staff/worker-type/edit',
        name: 'staff_worker_type_edit',
        meta: {
          hidden: true,
          title: '编辑工种',
          parentPath: '/staff',
          prevPath: '/staff/worker-type'
        },
        component: () => import('@/views/staff/worker-type/edit.vue')
      },

      // 薪酬规则新增/编辑
      {
        path: '/staff/salary-rule/add',
        name: 'staff_salary_rule_add',
        meta: {
          hidden: true,
          title: '新增薪酬规则',
          parentPath: '/staff',
          prevPath: '/staff/salary-rule'
        },
        component: () => import('@/views/staff/salary-rule/edit.vue')
      },
      {
        path: '/staff/salary-rule/edit',
        name: 'staff_salary_rule_edit',
        meta: {
          hidden: true,
          title: '编辑薪酬规则',
          parentPath: '/staff',
          prevPath: '/staff/salary-rule'
        },
        component: () => import('@/views/staff/salary-rule/edit.vue')
      },

      // 排班新增/编辑
      {
        path: '/staff/schedule/add',
        name: 'staff_schedule_add',
        meta: {
          hidden: true,
          title: '新增排班',
          parentPath: '/staff',
          prevPath: '/staff/schedule'
        },
        component: () => import('@/views/staff/schedule/edit.vue')
      },
      {
        path: '/staff/schedule/edit',
        name: 'staff_schedule_edit',
        meta: {
          hidden: true,
          title: '编辑排班',
          parentPath: '/staff',
          prevPath: '/staff/schedule'
        },
        component: () => import('@/views/staff/schedule/edit.vue')
      },

      // 薪酬结算详情
      {
        path: '/staff/salary-settlement/detail',
        name: 'staff_salary_settlement_detail',
        meta: {
          hidden: true,
          title: '薪酬结算详情',
          parentPath: '/staff',
          prevPath: '/staff/salary-settlement'
        },
        component: () => import('@/views/staff/salary-settlement/detail.vue')
      },

      // 转单记录详情
      {
        path: '/staff/transfer-record/detail',
        name: 'staff_transfer_record_detail',
        meta: {
          hidden: true,
          title: '转单记录详情',
          parentPath: '/staff',
          prevPath: '/staff/transfer-record'
        },
        component: () => import('@/views/staff/transfer-record/detail.vue')
      }
    ]
  }
]
